import Container from 'react-bootstrap/Container';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import Window from './Window';
import ImageModal from './ImageModal';
import { useEffect, useState } from 'react';

import { IMAGES } from '../Images';

export default function GalleryWindow({ setIsLoading }) {
  return (
    <section className="mt-4">
      <Window
        title="gallery.exe"
        barBgColor="#f97bff"
        borderColor="#c629c2"
        bgColor="#63006877"
      >
        <Gallery setIsLoading={setIsLoading} />
      </Window>
    </section>
  );
}

function Gallery({ setIsLoading }) {
  const [images, setImages] = useState([]);
  const [clickedImage, setClickedImage] = useState('');
  const [showModal, setShowModal] = useState(false);

  function handleShowImage(e) {
    setClickedImage(e.target.src);
    setShowModal(true);
  }

  function handleHideImage() {
    setShowModal(false);
    setClickedImage('');
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      const img = new Image();
      img.src = url;

      img.onload = () => {
        resolve(url);
      };

      img.addEventListener('error', function () {
        reject(new Error(`Image not found: ${url}`));
      });
    });
  }

  useEffect(
    function () {
      async function waitLoadImage() {
        try {
          setIsLoading(true);
          const data = await Promise.all(IMAGES.map((img) => loadImage(img)));
          setImages(data);
        } catch (err) {
          console.log(err.message);
        } finally {
          setIsLoading(false);
        }
      }
      waitLoadImage();
    },
    [setIsLoading]
  );
  return (
    <Container
      fluid
      className="overflow-auto hide-scroll"
      style={{ height: '81vh' }}
    >
      <ImageModal
        show={showModal}
        onHide={handleHideImage}
        imgSrc={clickedImage}
      />

      <div>&nbsp;</div>
      <ResponsiveMasonry columnsCountBreakPoints={{ 576: 2, 768: 3, 992: 4 }}>
        <Masonry columnsCount={4} gutter="5px">
          {images.map((image) => (
            <img
              className="grid-item"
              key={`galleryImg${image}`}
              src={image}
              alt="artwork"
              onClick={(e) => handleShowImage(e)}
            />
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </Container>
  );
}
